export default {
    xs: '480px',
    sm: '768px',
    md: '992px',
    lg: '1200px'
}